document.addEventListener('DOMContentLoaded', () => {
  const rootElements = document.getElementsByClassName('accordion');

  if (rootElements && rootElements.length > 0) {
    window.addEventListener('load', () => {
      Array.from(rootElements).forEach((rootElement) => {
        const items = rootElement.getElementsByClassName('accordion-item');
        Array.from(items).forEach((item) => {
          const heading = item.getElementsByClassName('accordion-item__heading')[0];
          heading.addEventListener('click', () => {
            item.classList.toggle('accordion-item--open');
          }, false);
        });
      });
    });
  }
});
